// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1auwn","inputWrap":"styles_inputWrap__1M-sh","input":"styles_input__3gMX9"};